export default __webpack_public_path__ + "media/zurb/img/home/netflix-logo-c049de8bab8e8ebfc8533c20c23dbacf.png";